import React from 'react';
import { motion } from 'framer-motion';
import RetailCard from './RetailCard';
import { FaAmazon, FaGoodreads, FaBook, FaLeaf } from 'react-icons/fa';
import { SiWalmart } from 'react-icons/si';
import { FiShoppingBag } from 'react-icons/fi';

const RetailGrid = () => {
  const retailers = [
    {
      name: "Amazon",
      cta: "Buy on Amazon",
      icon: FaAmazon,
      href: "https://www.amazon.com/Friendship-Pod-Affair-Miracle-Thought/dp/B0GN4RWVRZ/ref=sr_1_1?crid=3BPO4OZM49P2W&dib=eyJ2IjoiMSJ9.glQxUo8NZdihjPW5KN5Wsw.dK39VYIqjLkzma2EowpieJa3ivJtRc31ftBcV1XL6HA&dib_tag=se&keywords=A+Friendship+Pod+Affair+by+Ren%C3%A9e+Mollan-Masters&qid=1771437947&s=books&sprefix=a+friendship+pod+affair+by+ren%C3%A9e+mollan-masters%2Cstripbooks%2C342&sr=1-1#",
      delay: 0.1
    },
    {
      name: "Barnes & Noble",
      cta: "Shop B&N",
      icon: FaBook,
      href: "https://www.barnesandnoble.com/w/the-friendship-pod-affair-reni-e-mollan-masters/1149462518?ean=9798903010752",
      delay: 0.2
    },
    {
      name: "Walmart",
      cta: "Walmart Ebooks",
      icon: SiWalmart,
      href: "https://www.walmart.com/search?q=A+Friendship+Pod+Affair",
      delay: 0.3
    },
    {
      name: "Goodreads",
      cta: "Review on Goodreads",
      icon: FaGoodreads,
      href: "https://www.goodreads.com/book/show/247948320-the-friendship-pod-affair",
      delay: 0.4
    },
    {
      name: "ThriftBooks",
      cta: "Find on ThriftBooks",
      icon: FaLeaf,
      href: "https://www.thriftbooks.com/w/the-friendship-pod-affair-the-miracle-that-no-one-thought-could-happen_renee-mollan-masters/58194168/item/#edition=75161970&idiq=88228340",
      delay: 0.5
    },
    {
      name: "The Ewings",
      cta: "Direct Purchase",
      icon: FiShoppingBag,
      href: "https://www.theewingspublishing.com/product/the-friendship-pod-affair/",
      delay: 0.6
    }
  ];

  return (
    <section className="w-full py-16 px-6 bg-transparent">
      <div className="max-w-7xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-brand-dark mb-4">
            Get the Book
          </h2>
          <div className="h-1.5 w-24 bg-brand-gold mx-auto rounded-full" />
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-5">
          {retailers.map((retailer, index) => (
            <RetailCard key={index} {...retailer} />
          ))}
        </div>
        
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
          className="text-center mt-16"
        >
          <div className="inline-flex items-center gap-4 px-6 py-2 bg-brand-dark/5 rounded-full">
            <span className="text-[10px] uppercase tracking-[0.2em] font-bold text-brand-dark/60">Available Formats:</span>
            <span className="text-[10px] font-bold text-brand-dark uppercase">Hardcover</span>
            <span className="w-1 h-1 bg-brand-gold rounded-full" />
            <span className="text-[10px] font-bold text-brand-dark uppercase">Paperback</span>
            <span className="w-1 h-1 bg-brand-gold rounded-full" />
            <span className="text-[10px] font-bold text-brand-dark uppercase">E-Book</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default RetailGrid;